export enum CategType {
    TIME = 'time',
    INFO = 'info',
    COMMERCE = 'commerce',
    SOCIAL = 'social',
    NO_TITLE = 'no_title',
}

export enum OptColor {
    INFO = 'gray',
    COMMERCE = 'purple',
    SOCIAL = 'pink',
}

export type DimCategory = {
    display: string;
    values: Dimension[];
    type?: CategType;
    color?: OptColor;
};

export type Dimension = {
    display: string;
    value: string;
    fixed?: boolean;
    prefix?: string;
    type?: string;
    defaultCol?: boolean;
};
